import {
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  SkipSelf,
  ViewChild,
} from '@angular/core';
import { ControlContainer, NgModel, NgModelGroup } from '@angular/forms';
import { FormErrorService } from '@nx-ng/services';
import {
  IAddress,
  ICustomerDetailsErrors,
  AddressSearch,
  AddressMode,
} from '@nx-ng/types';
import { markAllAsTouched } from '@nx-ng/util';
import { v4 as uuidv4 } from 'uuid';
@Component({
  selector: 'nx-ng-address',
  templateUrl: './address.component.html',
  styleUrls: ['./address.component.scss'],
  viewProviders: [
    {
      provide: ControlContainer,
      useFactory: (container: ControlContainer) => container,
      deps: [[new SkipSelf(), ControlContainer]],
    },
  ],
})
export class AddressComponent {
  @Input()
  address: IAddress | undefined = undefined;

  @Input()
  errors: ICustomerDetailsErrors | undefined;

  @Input()
  readonly = false;

  @Input()
  fullName: string | undefined = undefined;

  @Input()
  modelGroupName = 'address';

  @Input()
  addressSearchContext = '';

  @Output()
  addressSearch: EventEmitter<AddressSearch> = new EventEmitter<AddressSearch>();

  @Output()
  addressFound: EventEmitter<void> = new EventEmitter<void>();

  @Output()
  postCodeManualChange: EventEmitter<string> = new EventEmitter<string>();

  @ViewChild('addressRef', { static: false }) addressGroup!: NgModelGroup;
  @ViewChild('pc', { static: false }) postcodeLookup!: NgModel;

  _mode: AddressMode = 'auto';
  @Input()
  get mode(): AddressMode {
    return this._mode;
  }
  set mode(value: AddressMode) {
    this._mode = value;
    if (
      this._mode == 'manual' &&
      this.address?.address1 &&
      this.addressGroup?.control
    ) {
      setTimeout(() => {
        markAllAsTouched(this.addressGroup.control);
      }, 0);
    }
  }

  id = uuidv4();

  constructor(private formsErrorService: FormErrorService) {}

  get isManualEntry() {
    return this.mode === 'manual';
  }

  handleManualEntryClick(): void {
    this.mode = 'manual';
  }

  handlePostcodeEntryClick(): void {
    this.mode = 'auto';
    if (!this.address) {
      return;
    }
    this.address.town = '';
    this.address.address1 = '';
    this.address.address2 = '';
    this.address.postCode = '';
  }

  getAddressLine1Error(address1: NgModel) {
    return this.formsErrorService.getAddress1Error(address1);
  }

  getTownError(town: NgModel) {
    return this.formsErrorService.getTownError(town);
  }

  getPostCodeError(postCode: NgModel) {
    return this.formsErrorService.getPostCodeError(postCode);
  }

  getLookupPostCodeError(postCode: NgModel) {
    return postCode.touched && this.mode === 'auto'
      ? 'postcode_lookup_please_select'
      : '';
  }

  handleAddressSearch(event: AddressSearch) {
    this.addressSearch.emit(event);
  }

  handleAddressFound(event: IAddress) {
    this.address!.address1 = event.address1;
    this.address!.address2 = event.address2;
    this.address!.town = event.town;
    this.address!.county = event.county;
    this.address!.postCode = event.postCode;

    this.mode = 'manual';
    this.addressFound.emit();
  }

  handleManualPostCodeChange(value: string) {
    this.postCodeManualChange.emit(value);
  }
}
